import { render, staticRenderFns } from "./AddVersionDialog.vue?vue&type=template&id=7304dae6&scoped=true"
import script from "./AddVersionDialog.vue?vue&type=script&lang=ts"
export * from "./AddVersionDialog.vue?vue&type=script&lang=ts"
import style0 from "./AddVersionDialog.vue?vue&type=style&index=0&id=7304dae6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7304dae6",
  null
  
)

export default component.exports